import React from 'react'
import { connect } from 'react-redux'
import moment from '../lib/moment'

import ReactDayPicker from 'react-day-picker'

import {
  selectDate,
  selectNextDate,
  toggleDatePicker,
  closeDatePicker,
} from '../actions/uiActions'

import {
  nowSelector,
  dateSelector,
  datePickerIsOpenSelector,
} from '../reducers/uiReducer'

import styles from './DatePicker.module.css'

import iconNext  from '../assets/images/icon-next-arrow.svg'
import iconPrev  from '../assets/images/icon-prev-arrow.svg'
import iconDay   from '../assets/images/icon-calendar-day.svg'
import iconMonth from '../assets/images/icon-calendar-month.svg'


// Displayed date formats
const dayFormat   = 'ddd, MMM Do'
const monthFormat = 'MMMM YYYY'

// Open/Close animation duration
// *Must* match the transition duration in the CSS
const CONTAINER_ANIMATION_DURATION = 300


class DatePickerView extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      month: props.selectedDate.clone()
    }
  }

  componentWillReceiveProps(nextProps) {
    const prevProps = this.props

    // If the date picker is about to open, reset the month to the selectedDate
    if (nextProps.isOpen && nextProps.isOpen !== prevProps.isOpen) {
      this.setState({
        month: nextProps.selectedDate.clone()
      })
    }
  }

  componentWillUpdate(nextProps) {
    this.animateOpenClose(this.props, nextProps)
  }

  // This is a workaround for the fact that CSS transitions cannot animate
  // between a fixed dimension and 'auto'. The approach requires manipulating
  // the DOM. To open, we temporarily fix the container height to its
  // scrollHeight while the CSS transition is underway, then set it back to
  // 'auto' so that it can react to any changes in viewport or content
  // dimensions.
  //
  // States:
  //   - Open:      height = 'auto'
  //   - Closed:    height = null (use whatever the stylesheet declares)
  //   - Animating: height = fixed to its scrollHeight
  //
  animateOpenClose(prevProps, nextProps) {

    // only run if the isOpen prop has changed and if this.containerElement is
    // attached.
    if (prevProps.isOpen !== nextProps.isOpen && this.containerElement) {
      const el = this.containerElement

      // Cancel any animation timeouts currently underway.
      clearTimeout(this.openCloseTimeout)

      // Temporarily assign container element height in pixels so that the CSS
      // transition can work.
      el.style.height = el.scrollHeight + 'px'

      if (nextProps.isOpen) {

        // Reset the container height to 'auto' when the CSS transition is
        // complete
        this.openCloseTimeout = setTimeout(function() {
          el.style.height = 'auto'
        }, CONTAINER_ANIMATION_DURATION)
      }
      else {

        // Reset the container height to its original CSS declaration on the
        // next CPU tick to CSS transition to the closed position
        this.openCloseTimeout = setTimeout(function() {
          el.style.height = null
        })
      }
    }
  }

  displayDate = () => {
    const { isOpen, selectedDate } = this.props
    const { month } = this.state

    return (isOpen)
      ? month.format(monthFormat)
      : selectedDate.format(dayFormat)
  }

  calendarIcon = () => {
    const { isOpen } = this.props

    return (isOpen)
      ? iconMonth
      : iconDay
  }

  prevMonth = () => {
    const currentMonth = this.state.month

    this.setState({
      month: currentMonth.subtract(1, 'month')
    })
  }

  nextMonth = () => {
    const currentMonth = this.state.month

    this.setState({
      month: currentMonth.add(1, 'month')
    })
  }

  handlePrev = () => {
    const { isOpen, selectPrevDay } = this.props

    if (isOpen)
      this.prevMonth()
    else
      selectPrevDay()
  }

  handleNext = () => {
    const { isOpen, selectNextDay } = this.props

    if (isOpen)
      this.nextMonth()
    else
      selectNextDay()
  }

  handleToday = () => {
    this.props.closeDatePicker()
    this.props.selectToday()
  }

  handleDayClick = (date) => {
    this.props.closeDatePicker()
    this.props.selectDate(date)
  }

  handleToggle = () => {
    this.props.toggleDatePicker()
  }

  shouldShowTodayButton = () => {
    const { isOpen, now, selectedDate } = this.props
    return isOpen && !now.isSame(selectedDate, 'day')
  }

  // Attach the container DOM element to assist with the open/close animation.
  // (see this.animateOpenClose)
  attachContainerElement = (ref) => {
    this.containerElement = ref
  }

  render() {
    const {
      isOpen,
      selectedDate,
    } = this.props

    const { month } = this.state

    return (
      <div
        className={styles.DatePicker}
        ref={this.attachContainerElement}
      >
        <div className={styles.innerWrapper}>
          <NavbarElement
            handleToday={this.handleToday}
            handlePrev={this.handlePrev}
            handleNext={this.handleNext}
            handleToggle={this.handleToggle}
            displayDate={this.displayDate()}
            calendarIcon={this.calendarIcon()}
            shouldShowTodayButton={this.shouldShowTodayButton()}
          />
          <ReactDayPicker
            classNames={styles}
            month={month.toDate()}
            captionElement={()=>null}
            navbarElement={() =>null}
            selectedDays={selectedDate.toDate()}
            onDayClick={this.handleDayClick}
            showOutsideDays={true}
            fixedWeeks={true}
          />
        </div>
      </div>
    )
  }
}

function NavbarElement(props) {
  const {
    handleToday,
    handlePrev,
    handleNext,
    handleToggle,
    displayDate,
    calendarIcon,
    shouldShowTodayButton,
  } = props

  let displayDateClassNames = styles.displayDate
  let todayButtonClassNames = styles.todayButton
  if (shouldShowTodayButton) {
    displayDateClassNames += ' ' + styles.showToday
    todayButtonClassNames += ' ' + styles.showToday
  }

  return (
    <div className={styles.navbar}>
      <a className={styles.navButtonPrev} onClick={handlePrev} ripple=''>
        <img src={iconPrev} />Prev
      </a>
      <div className={displayDateClassNames} onClick={handleToggle}>
        {displayDate}
        <img src={calendarIcon} />
      </div>
      <div className={todayButtonClassNames} onClick={handleToday}>
        Return to today
      </div>
      <a className={styles.navButtonNext} onClick={handleNext} ripple=''>
        Next<img src={iconNext} />
      </a>
    </div>
  )
}





export default connect(
  (state) => {
    return {
      now: nowSelector(state),
      selectedDate: dateSelector(state),
      isOpen: datePickerIsOpenSelector(state),
    }
  },
  (dispatch, ownProps) => {

    return {
      selectNextDay: function() {
        dispatch(selectNextDate(1, 'day'))
      },
      selectPrevDay: function() {
        dispatch(selectNextDate(-1, 'day'))
      },
      selectDate: function(date, modifiers, e) {
        dispatch(selectDate(date))
      },
      selectToday: function() {
        dispatch(selectDate())
      },
      toggleDatePicker: function() {
        dispatch(toggleDatePicker())
      },
      closeDatePicker: function() {
        dispatch(closeDatePicker())
      },
    }
  }
)(DatePickerView)



// WEBPACK FOOTER //
// ./src/components/DatePicker.js